//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export ClientListConfig
export const BankSearchConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path: "/app/bankRec/searchBank",
      component: FuseLoadable({
        loader: () => import("./SearchBank.js")
      })
    }
  ]
  //end routes
};
